var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 20,
    fill: "#FF0000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4396_28276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    width: 15.6133,
    height: 15.6133,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4396_28276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.80473 10.7175L5.61702 13.9052C5.49775 14.0244 5.34596 14.0841 5.16163 14.0841C4.97731 14.0841 4.82551 14.0244 4.70625 13.9052C4.58698 13.7859 4.52734 13.6341 4.52734 13.4498C4.52734 13.2655 4.58698 13.1137 4.70625 12.9944L7.89396 9.80669L4.70625 6.61897C4.58698 6.49971 4.52734 6.34791 4.52734 6.16359C4.52734 5.97926 4.58698 5.82747 4.70625 5.7082C4.82551 5.58893 4.97731 5.5293 5.16163 5.5293C5.34596 5.5293 5.49775 5.58893 5.61702 5.7082L8.80473 8.89591L11.9924 5.7082C12.1117 5.58893 12.2635 5.5293 12.4478 5.5293C12.6322 5.5293 12.7839 5.58893 12.9032 5.7082C13.0225 5.82747 13.0821 5.97926 13.0821 6.16359C13.0821 6.34791 13.0225 6.49971 12.9032 6.61897L9.71551 9.80669L12.9032 12.9944C13.0225 13.1137 13.0821 13.2655 13.0821 13.4498C13.0821 13.6341 13.0225 13.7859 12.9032 13.9052C12.7839 14.0244 12.6322 14.0841 12.4478 14.0841C12.2635 14.0841 12.1117 14.0244 11.9924 13.9052L8.80473 10.7175Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseInput);
export default __webpack_public_path__ + "static/media/close-input.c5c0ba9d4192c4ae409f72909a6a93c5.svg";
export { ForwardRef as ReactComponent };